import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { RootState } from 'modules';
import { TSubTheme, TLearningParams, TRecommendCardBox } from 'modules/learning';
import { CMAIN_THEMES, CFINANCE_THEME } from 'constants/learningboard.const';
import { ERoute } from 'enums/route.enum';
import { Button } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

const RecommendCardBox = ({ title, list }: TRecommendCardBox) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const { category, step_id }: TLearningParams = useParams();

  const [{ name }] =
    currentUser?.primary_field !== 'finance'
      ? CMAIN_THEMES.filter(({ link }) => link === category)
      : CFINANCE_THEME.filter(({ link }) => link === category);

  return (
    <>
      {list && (
        <StyledContainer>
          <StyledHeader>{title}</StyledHeader>
          <StyledCardList>
            {list.map(({ id, thumbnail, title, subtitle }: TSubTheme) => (
              <StyledCard key={id}>
                <StyledCardThumnail src={thumbnail.location} />
                <StyledCardInformation>
                  <StyledCardSubject>{name}</StyledCardSubject>
                  <StyledCardTitle>{title}</StyledCardTitle>
                  {subtitle && (
                    <StyledCardSubtitle
                      dangerouslySetInnerHTML={{
                        __html: subtitle.replace('<br>', ''),
                      }}
                    />
                  )}
                  <Link to={`${ERoute.CSLearningBoard}/${category}/${step_id}/${id}/view`}>
                    <Button className='ant-btn-primary'>읽기</Button>
                  </Link>
                </StyledCardInformation>
              </StyledCard>
            ))}
          </StyledCardList>
        </StyledContainer>
      )}
    </>
  );
};

export default RecommendCardBox;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  padding: 50px 0;
  background-color: #f9f9f9;
`;

const StyledCardList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 810px;
  margin-top: 10px;

  @media screen and ${device.lg} {
    width: 540px;
  }

  @media screen and ${device.sm} {
    width: 270px;
  }
`;

const StyledHeader = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #003159;
`;

const StyledCard = styled.div`
  width: 254px;
  margin: 27px 8px 20px 8px;
`;

const StyledCardThumnail = styled.img`
  width: 100%;
  height: 195px;
  border-radius: 10px 10px 0px 0px;
  object-fit: cover;
`;

const StyledCardInformation = styled.section`
  height: 315px;
  padding: 20px 25px 20px 25px;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;

  .ant-btn-primary {
    width: 100%;
  }

  .secondary {
    padding: 3px 10px;
    height: 26px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`;

const StyledCardSubject = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  background-color: #3cac40;
`;

const StyledCardTitle = styled.div`
  display: -webkit-box;
  height: 85px;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

const StyledCardSubtitle = styled.div`
  display: -webkit-box;
  height: 100px;
  margin: 10px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #14112a;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`;
